<template>
  <div class="preview-container">
    <div
      v-for="(block, index) in enabledBlocks"
      :key="index"
      class="preview-block"
      :class="`preview-block--${block.color || 'primary'}`"
    >
      <div class="preview-header">
        <v-icon class="preview-icon">{{ block.icon || 'mdi-information' }}</v-icon>
        <div class="preview-title">{{ block.title || 'Заголовок новости' }}</div>
        <v-spacer></v-spacer>
        <small v-if="block.id" class="text-caption grey--text">
          ID: {{ block.id }}
        </small>
        <small v-else class="text-caption grey--text">
          Новый блок (несохраненный)
        </small>
      </div>
      <div class="preview-content">
        <p class="preview-description">{{ block.description || 'Краткое описание новости' }}</p>
        <div v-if="block.date" class="preview-date">
          <v-icon small class="mr-1">mdi-calendar</v-icon>
          {{ block.date }}
        </div>
        <div v-if="block.phone" class="preview-phone">
          <v-icon small class="mr-1">mdi-phone</v-icon>
          {{ block.phone }}
        </div>
        <div v-if="block.type" class="preview-type">
          <v-chip small :color="`${block.color || 'primary'}`" text-color="white">
            {{ getTypeLabel(block.type) }}
          </v-chip>
        </div>
      </div>
    </div>

    <v-alert
      v-if="enabledBlocks.length === 0"
      type="warning"
      class="mt-4"
    >
      Нет активных новостей для отображения на главной странице.
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'ArticlePreview',
  props: {
    blocks: {
      type: Array,
      required: true,
    },
  },
  computed: {
    enabledBlocks () {
      return this.blocks.filter(block => block.enabled);
    },
  },
  methods: {
    // getTypeColor (type) {
    //   const colors = {
    //     news: 'primary',
    //     reminder: 'success',
    //     important: 'error',
    //     info: 'info',
    //   };
    //   return colors[type] || 'primary';
    // },
    getTypeLabel (type) {
      const labels = {
        news: 'Новость',
        reminder: 'Памятка',
        marketing: 'Реклама',
        important: 'Важно',
        info: 'Информация',
      };
      return labels[type] || 'Новость';
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-container {
  max-height: 500px;
  overflow-y: auto;
}

.preview-block {
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  .preview-header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .preview-icon {
      font-size: 24px;
      margin-right: 12px;
    }

    .preview-title {
      font-size: 16px;
      font-weight: 600;
    }
  }

  .preview-content {
    .preview-description {
      margin: 0 0 12px 0;
      font-size: 14px;
      color: #666;
      line-height: 1.4;
    }

    .preview-date {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }
    .preview-phone {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }
    .preview-type {
      margin-top: 8px;
    }
  }
}

.preview-block--primary {
  border-left: 4px solid #1976d2;
  .preview-icon { color: #1976d2; }
}

.preview-block--success {
  border-left: 4px solid #4caf50;
  .preview-icon { color: #4caf50; }
}

.preview-block--warning {
  border-left: 4px solid #ff9800;
  .preview-icon { color: #ff9800; }
}

.preview-block--error {
  border-left: 4px solid #f44336;
  .preview-icon { color: #f44336; }
}

.preview-block--purple {
  border-left: 4px solid #9c27b0;
  .preview-icon { color: #9c27b0; }
}

.preview-block--teal {
  border-left: 4px solid #009688;
  .preview-icon { color: #009688; }
}
</style>
